module.exports = __webpack_public_path__ + "media/images/emblems/Felben-Wellhausen-Blazono-c36a98ea2c9e7b90bf9831c8a78f74a8.png";